import React from 'react';

import { Drawer } from '@components/Drawer';
import { Sidebar } from '@components/Sidebar';
import { useDirection } from '@providers/Direction';

import { useWebNavigationContainer } from './WebNavigationContainer';

export const WebNavigationDrawer: React.FC = () => {
  const { isOpen, closeDrawer } = useWebNavigationContainer();
  const { direction } = useDirection();

  return (
    <Drawer
      open={isOpen}
      direction={direction === 'ltr' ? 'left' : 'right'}
      onClose={closeDrawer}
      duration={300}>
      <Sidebar />
    </Drawer>
  );
};
